import { Get_Cart_List } from "../../api/category_product/Category_Product";
import { FETCH_CART_LIST_REQUEST, FETCH_CART_LIST_SUCCESS, FETCH_CART_LIST_FAILURE, FETCH_USER_PROFILE_FAILURE } from "../types";

export const fetchCartList = ({ showLoader = true } = {}) => async (dispatch, getState) => {

    // const { cartlist } = getState();
    // const { status } = cartlist;

    // if (status === "pending") {
    //     return;
    // }

    // if (status === "success") {
    //     return;
    // }

    if (showLoader) {
        dispatch({ type: FETCH_CART_LIST_REQUEST });
    }
    try {
        const token = localStorage.getItem("user_token");
        if (!token) {
            throw new Error("Token not found");
        }

        const headers = { Authorization: `Bearer ${token}` };
        const response = await Get_Cart_List(headers);
        const { cartlist, Shipping_amount } = response.data.data;
        if (response?.status === 401) {            
            dispatch({ type: FETCH_USER_PROFILE_FAILURE, payload: "Unauthorized" });
            localStorage.removeItem("user_token");
            return { unauthorized: true }; // <--- Return flag
        }
        if (response?.data?.status) {
            dispatch({
                type: FETCH_CART_LIST_SUCCESS, payload: {
                    cartlist,
                    Shipping_amount,
                },
            });
        } else {
            dispatch({ type: FETCH_CART_LIST_FAILURE, payload: "Failed to fetch profile" });
        }
    } catch (error) {
        dispatch({ type: FETCH_CART_LIST_FAILURE, payload: error.message });
        return { unauthorized: true };
    }
};